<ng-template>
  <div
    (click)="closed.emit()"
    class="tw-flex tw-shrink-0 tw-flex-col tw-rounded-lg tw-border tw-border-solid tw-border-secondary-100 tw-bg-background tw-shadow-md tw-bg-clip-padding tw-py-1 tw-overflow-y-auto"
    [attr.role]="ariaRole()"
    [attr.aria-label]="ariaLabel()"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="ariaRole() === 'dialog'"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
